import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import bookingApi from "../../api/booking/BookingApi";
import { useEffect } from "react";
import Loading from "../../Util/Loading";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AiFillStar } from "react-icons/ai";
import ConfirmDialog from "./ConfirmDialog";
import MultiSelectModal from "./MultiSelectModal";

import SelectProfessional from "./SelectProfessional";
import TimeSlotSelector from "./Timeslotselector";
import Layout from "../../Layout";
import { BiPlus } from "react-icons/bi";
import sericesApi from "../../api/user/service.api";
import staffApi from "../../api/user/staff.api";
import { IoArrowBackOutline } from "react-icons/io5";
import ProcessingBar2 from "../../components/ProcessingBar/ProcessingBar2";
import ProcessingBar from "../../components/ProcessingBar/ProcessingBar";
import { useLocation } from "react-router-dom";

function BookingModify() {
  const { id } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const selectedDateTimeFromCalendar = location.state?.selectedDateTime || null;
  const selectedProfessionalFromCalendar =
    location.state?.selectedProfessional || null;

  const user = useSelector((state) => state.user);

  const [booking, setBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedNailServices, setSelectedNailServices] = useState([]);
  const [selectedNailIds, setSelectedNailIds] = useState([]);

  const [selectedBeautyServices, setSelectedBeautyServices] = useState([]);
  const [selectedBeautyIds, setSelectedBeautyIds] = useState([]);

  const [selectedDateTime, setSelectedDateTime] = useState(
    selectedDateTimeFromCalendar
  );

  const [selectedProfessional, setSelectedProfessional] = useState([]);

  const [note, setNote] = useState("");

  const [nails, setNails] = useState([]);
  const [beauty, setBeauty] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [totalTimeNail, setTotalTimeNail] = useState(0);
  const [totalTimeBeauty, setTotalTimeBeauty] = useState(0);

  const [customerName, setCustomerName] = useState(user?.user?.name || "");
  const [email, setEmail] = useState(user?.user?.email || "");
  const [mobile, setMobile] = useState(user?.user?.phone || "");

  // console.log({ booking });

  const operatorId = user?.user?._id;
  console.log({ operatorId });

  const getBeautyData = async () => {
    try {
      const { response, err } = await sericesApi.getallBeauty({ operatorId });

      if (response && response.data) {
        setBeauty(response.data.beautyservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getNailData = async () => {
    try {
      const { response, err } = await sericesApi.getallNail({ operatorId });

      if (response && response.data) {
        setNails(response.data.nailservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBeautyData(), getNailData(), getAllStaff()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getAllStaff = async () => {
    try {
      let operatorId = user?.user?._id;

      const { response, err } = await staffApi.getAllStaffInfo(operatorId);

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const loading = false;

  const isCancelled = booking?.booking?.status === "cancelled";
  const isPast =
    selectedDateTime && new Date(selectedDateTime).getTime() < Date.now();

  const SectionCard = ({ title, children }) => (
    <div className="bg-drylight p-8 rounded-2xl shadow border border-border">
      <h4 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-2">
        {title}
      </h4>
      <div>{children}</div>
    </div>
  );

  const cancelBookingHandler = () => {
    navigate(`/listofbooking`);
  };

  const [isProcessing, setIsProcessing] = useState(false);

  const handleCreateBooking = async () => {
    try {
      const payload = {
        selectedNailServices,
        selectedBeautyServices,
        selectedProfessional,
        selectedDateTime,
        note,
      };

      const formData = {
        operator: user?.user?._id,
        user: user?.user?._id,
        selectedNailServices,
        selectedBeautyServices,
        selectedProfessionalId: selectedProfessional,
        selectedDateTime,
        totalTimeNail,
        totalTimeBeauty,
        name: user?.user?.name,
        email: user?.user?.email,
        message: note,
        mobile: user?.user?.phone,
        bookingtype: "walk-in",
      };

      setIsProcessing(true);

      console.log({ formData });

      const { response, err } = await bookingApi.createBooking(formData);
      if (err) throw err;
      toast.success("Booking updated successfully!");
      navigate("/listofbooking");
    } catch (error) {
      toast.error("Failed to update booking");
      console.error(error);
    } finally {
      setIsProcessing(false); // ✅ Always stop loading
    }
  };

  const [showProfessional, setShowProfessional] = useState(false);
  const [showTimeSlot, setShowTimeSlot] = useState(false);
  const [showCustomerInfo, setShowCustomerInfo] = useState(false);
  const [loadingProfessional, setLoadingProfessional] = useState(false);
  const [loadingTimeSlot, setLoadingTimeSlot] = useState(false);
  const [loadingCustomerInfo, setLoadingCustomerInfo] = useState(false);

  useEffect(() => {
    if (selectedNailServices.length || selectedBeautyServices.length) {
      setShowProfessional(false);
      setShowTimeSlot(false);
      setShowCustomerInfo(false);

      setLoadingProfessional(true);

      const timer = setTimeout(() => {
        setLoadingProfessional(false);
        setShowProfessional(true);
      }, 1500);

      return () => {
        clearTimeout(timer);
        setLoadingProfessional(false);
      };
    } else {
      setShowProfessional(false);
      setShowTimeSlot(false);
      setShowCustomerInfo(false);
      setLoadingProfessional(false);
    }
  }, [selectedNailServices, selectedBeautyServices]);

  useEffect(() => {
    if (selectedProfessional.length !== 0) {
      setShowTimeSlot(false);
      setShowCustomerInfo(false);

      setLoadingTimeSlot(true);
      setLoadingCustomerInfo(true);

      const timer1 = setTimeout(() => {
        setLoadingTimeSlot(false);
        setShowTimeSlot(true);
      }, 1000);

      const timer2 = setTimeout(() => {
        setLoadingCustomerInfo(false);
        setShowCustomerInfo(true);
      }, 1800);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        setLoadingTimeSlot(false);
        setLoadingCustomerInfo(false);
      };
    } else {
      setShowTimeSlot(false);
      setShowCustomerInfo(false);
      setLoadingTimeSlot(false);
      setLoadingCustomerInfo(false);
    }
  }, [selectedProfessional]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Layout>
      <div className="flex items-center gap-4">
        <Link
          to="/appointments"
          className="bg-dry border border-subMain rounded-lg py-3 px-4 text-md text-subMain"
        >
          <IoArrowBackOutline />
        </Link>
        <h1 className="text-xl font-semibold text-subMain">
          New Walk-In Booking
        </h1>
      </div>
      {loading ? (
        <div className="flex-colo h-96">
          <Loading />
        </div>
      ) : (
        <div className="w-full mx-auto p-6 border border-border text-white space-y-6 mt-8 rounded-xl h-screen">
          <MultiSelectModal
            options={nails}
            totalTime={totalTimeNail}
            setTotalTime={setTotalTimeNail}
            selectedValues={selectedNailServices}
            setSelectedValues={setSelectedNailServices}
            selectedId={selectedNailIds}
            setSelectedId={setSelectedNailIds}
            label="Nail Services"
          />

          <MultiSelectModal
            options={beauty}
            totalTime={totalTimeBeauty}
            setTotalTime={setTotalTimeBeauty}
            selectedValues={selectedBeautyServices}
            setSelectedValues={setSelectedBeautyServices}
            selectedId={selectedBeautyIds}
            setSelectedId={setSelectedBeautyIds}
            label="Beauty Services"
          />

          {loadingProfessional && (
            <div className="w-full flex justify-center py-4">
              <ProcessingBar2 />
            </div>
          )}

          {showProfessional && (
            <SelectProfessional
              label="Staff"
              staffs={staffs}
              selectedId={selectedProfessional}
              onChange={setSelectedProfessional}
              selectedNailservices={selectedNailServices || []}
              selectedBeautyservices={selectedBeautyServices || []}
            />
          )}

          {loadingTimeSlot && (
            <div className="w-full flex justify-center py-4">
              <ProcessingBar2 />
            </div>
          )}

          {showTimeSlot && (
            <TimeSlotSelector
              selectedDateTime={selectedDateTime}
              setSelectedDateTime={setSelectedDateTime}
              staffs={staffs}
              selectedProfessionalId={selectedProfessional}
            />
          )}

          {loadingCustomerInfo && (
            <div className="w-full flex justify-center py-4">
              <ProcessingBar2 />
            </div>
          )}

          {showCustomerInfo && (
            <>
              <h2 className="text-xl text-text font-bold mt-8">
                Customer Info
              </h2>
              <div className="border border-border p-4 rounded-lg space-y-4">
                <div>
                  <label className="text-sm text-gray-400">Name</label>
                  <input
                    type="text"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    className="w-full p-2 mt-1 rounded bg-dry text-white border border-yellowlight"
                    placeholder="Customer name"
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-400">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full p-2 mt-1 rounded bg-dry text-white border border-yellowlight"
                    placeholder="Customer email"
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-400">Phone</label>
                  <input
                    type="tel"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    className="w-full p-2 mt-1 rounded bg-dry text-white border border-yellowlight"
                    placeholder="Customer phone"
                  />
                </div>
              </div>

              <h2 className="text-xl font-bold mt-8">Notes</h2>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                className="w-full p-3 rounded-xl border border-yellowlight text-text bg-dry text-lg"
                rows={4}
                placeholder="Write notes about your appointment..."
              />
            </>
          )}
          <div className="pt-6 border-t border-border">
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={cancelBookingHandler}
                className="w-full px-6 py-3 dg-dry border border-border hover:text-red-500 text-yellowlight rounded-2xl font-semibold text-lg shadow"
              >
                Cancel
              </button>

              <button
                onClick={handleCreateBooking}
                disabled={!selectedProfessional || !selectedDateTime}
                className={`w-full px-6 py-3 rounded-2xl font-semibold text-lg shadow transition-all
                  ${
                    !selectedProfessional || !selectedDateTime
                      ? "bg-gray-400 text-white cursor-not-allowed"
                      : "bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark"
                  }`}
              >
                {isProcessing ? <ProcessingBar /> : "New Walk in Appointment"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default BookingModify;
